export var has = function (Component) { return ({
    Component: Component,
    kind: 'has',
    __isFilter: true,
    toString: function () {
        return "has(" + Component.name + ")";
    },
}); };
export var not = function (Component) { return ({
    Component: Component,
    kind: 'not',
    __isFilter: true,
    toString: function () {
        return "not(" + Component.name + ")";
    },
}); };
export var changed = function (Component) { return ({
    Component: Component,
    kind: 'changed',
    __isFilter: true,
    toString: function () {
        return "changed(" + Component.name + ")";
    },
}); };
export var any = function () {
    var Components = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        Components[_i] = arguments[_i];
    }
    return ({
        Components: Components,
        kind: 'any',
        __isFilter: true,
        toString: function () {
            return "any(" + Components.map(function (Comp) { return Comp.name; }).join(', ') + ")";
        },
    });
};
export var isFilter = function (thing) {
    return thing.__isFilter === true;
};
export var isNotFilter = function (fil) {
    return fil.kind === 'not';
};
export var isHasFilter = function (fil) {
    return fil.kind === 'has';
};
export var isChangedFilter = function (fil) { return fil.kind === 'changed'; };
export var isAnyFilter = function (fil) { return fil.kind === 'any'; };
//# sourceMappingURL=filters.js.map